import RegisterRouter from './router';

export default RegisterRouter;
